// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__xs1he","theme-gray":"Section_theme-gray__iInZb"};